import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HorizontalFormBlockWrapper from '../../components/forms/HorizontalFormBlockWrapper';
import RequiredInput from '../../components/forms/InputHOC';
import PageHeader from '../../layout/shared/page-header';
import { menuRoutes } from '../../router/menu';
import FormFooter from '../_layout/_footers/form-footer';
import { useSettingsProvider } from './provider/SettingsProvider';

const GeneralsSettingsPage: React.FC = () => {

    const { formik, hasCompanyConfigChanges, isLoading, companyConfig, updateCompanyConfig, setShowModal, discardCompanyConfigChanges } = useSettingsProvider();
    const location = useLocation();

    const invoicePageHeader = {
        title: 'Ajustes en Facturas',
        breadcrumb: [
            { name: 'Inicio', href: menuRoutes.dashboard.path },
            { name: 'Configuración' },
            { name: 'Facturas', href: menuRoutes.settings.path + '#invoices' },
        ]
    }

    const incidencePageHeader = {
        title: 'Ajustes en Incidencias',
        breadcrumb: [
            { name: 'Inicio', href: menuRoutes.dashboard.path },
            { name: 'Configuración' },
            { name: 'Incidencias', href: menuRoutes.settings.path + '#incidences' },
        ]
    }

    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace('#', '');
            const element = document.getElementById(id);

            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [location]);

    return (
        <div className='h-full overflow-auto scrollbar '>
            <div id="invoices" className='mb-4'>
                <PageHeader
                    title={invoicePageHeader.title}
                    breadcrumb={invoicePageHeader.breadcrumb}
                    className='border-b-4 border-dotted border-grey-500 top-0'
                    isSticky={false}
                />
                <HorizontalFormBlockWrapper
                    title="Recordatorios de Facturas"
                    description="Configura los avisos automáticos relacionados con vencimientos y pagos."
                    descriptionClassName="max-w-[50%]"
                    childrenWrapperClassName="@md:col-span-10 md:grid-cols-2"
                >
                    <RequiredInput
                        id="daysBeforeExpirationCollectionDate"
                        label="Recordatorio de pago"
                        type="number"
                        value={companyConfig?.daysBeforeExpirationCollectionDate}
                        onChange={(e) => {
                            updateCompanyConfig('daysBeforeExpirationCollectionDate', e.target.value);
                            formik.setFieldValue('daysBeforeExpirationCollectionDate', e.target.value);
                        }}
                        error={formik.errors.daysBeforeExpirationCollectionDate}
                    />

                    <RequiredInput
                        id="daysAfterNonPaymentExpiration"
                        label={<span>Recordatorio de pago vencido <span className='text-muted500 ms-2'>Cantidad de días para envio de correo después de la fecha de vencimiento (impago)</span></span>}
                        type="number"
                        value={companyConfig?.daysAfterNonPaymentExpiration}
                        onChange={(e) => {
                            updateCompanyConfig('daysAfterNonPaymentExpiration', e.target.value);
                            formik.setFieldValue('daysAfterNonPaymentExpiration', e.target.value);
                        }}
                        error={formik.errors.daysAfterNonPaymentExpiration}
                    />
                </HorizontalFormBlockWrapper>
            </div>

            <div id="incidences" className='mb-4'>
                <PageHeader
                    title={incidencePageHeader.title}
                    breadcrumb={incidencePageHeader.breadcrumb}
                    className='border-b-4 border-dotted border-grey-500 top-0'
                    isSticky={false}
                />
                <HorizontalFormBlockWrapper
                    title="Formato del nombre de las Incidencias"
                    description="Las variables disponibles son las siguientes : {{NUMBER}} "
                    descriptionClassName="max-w-[50%]"
                    childrenWrapperClassName="@3xl:grid-cols-1 max-w-[50%] w-full"
                >
                    <div className='pb-4'>
                        <RequiredInput
                            id="incidenceName"
                            label="Nombre de la Incidencia"
                            value={companyConfig?.incidenceCodeFormat}
                            onChange={(e) => {
                                updateCompanyConfig('incidenceCodeFormat', e.target.value);
                                formik.setFieldValue('incidenceCodeFormat', e.target.value);
                            }}
                            error={formik.errors.incidenceCodeFormat}
                        />
                    </div>
                </HorizontalFormBlockWrapper>
            </div>

            {hasCompanyConfigChanges && (
                <FormFooter
                    customClassName={"w-full"}
                    submitBtnText={"Aplicar Cambios"}
                    cancelBtnText={"Descartar Cambios"}
                    handleCancelBtn={() => discardCompanyConfigChanges()}
                    handleSubmitBtn={() => setShowModal(true)}
                    isLoading={isLoading}
                    isDisabled={Object.keys(formik.errors).length > 0}
                />
            )}
        </div>
    );
};

export default GeneralsSettingsPage;
